import { rdData } from "Root/profile/components/RDPageV2/YourRD";
import { _getQuanityString, _getFlavorString, } from "Root/profile/components/SubscriptionPageV2/SubscriptionItem/useSubscriptionItem";
import { useDispatch, useSelector } from "react-redux";
import matt_png from "Images/profile/matt.png";
import mary_png from "Images/profile/mary_img.png";
import { applyPromoCheckout, removePromoCheckout, setDiscountStr, } from "Root/checkout/redux/slices/checkoutPricingSlice";
import { useScreenWidth } from "Root/profile/components/SubscriptionPageV2/hooks";
import { useState } from "react";
export const formatPrice = (cents) => {
    const dollars = cents / 100;
    return `$${dollars.toFixed(2)}`;
};
const useCheckoutOrderSummary = () => {
    const dispatch = useDispatch();
    const shippingData = useSelector((state) => state.checkoutShipping.address);
    const promoError = useSelector((state) => state.checkoutPricing.promoError);
    const userCart = useSelector((state) => state.checkoutUserCart.userCart);
    const myRD = useSelector((state) => state.dietitian);
    const { otb, subscription, plan } = useSelector((state) => state.checkoutPricing);
    const isOtb = plan === "otb";
    const isMobile = useScreenWidth() < 968;
    const [openSummaryDrawer, setOpenSummaryDrawer] = useState(false);
    const toggleDrawer = (value) => () => {
        if (value) {
            document.body.scrollIntoView({ block: "start", inline: "nearest", behavior: "smooth" });
        }
        else {
            document.body.style.removeProperty("overflow");
        }
        setOpenSummaryDrawer(value);
    };
    const getQuanityString = (qty, item_type, servings) => {
        return _getQuanityString(qty, item_type, servings);
    };
    const getFlavorString = (available_flavors, bags_info) => {
        return _getFlavorString(available_flavors, bags_info);
    };
    const isDuty = useSelector((state) => state.checkoutShipping.address.country === "CA");
    const calculateTotalPriceWithoutBottle = () => {
        const waterBottleCost = userCart
            .filter((item) => item.item_type === "waterbottle" ||
            item.item_type === "blenderbottle" ||
            item.item_type === "wb221" ||
            item.item_type === "wb222" ||
            item.item_type === "frother")
            .reduce((acc, item) => acc + Number(item.gross_price?.replace("$", "")), 0);
        const fullPrice = subscription.subtotal;
        return formatPrice(fullPrice - waterBottleCost * 100);
    };
    const totalPrice = plan === "otb" ? otb.total : subscription.total;
    const unlockSavings = () => {
        return "";
    };
    const rdImage = myRD.assigned_RD && myRD.assigned_RD.toLowerCase() === "mary" ? mary_png : matt_png;
    const rdName = myRD.assigned_RD && rdData[myRD.assigned_RD].name;
    const applyPromo = async (value, shippingSpeed) => {
        await dispatch(applyPromoCheckout({ promo: value, shippingSpeed: shippingSpeed, isOtb: isOtb }));
    };
    const removePromo = async (value, shippingSpeed) => {
        dispatch(setDiscountStr(subscription.promo_code.filter((item) => item !== value)));
        await dispatch(removePromoCheckout({ promo: value, shippingSpeed: shippingSpeed, isOtb: isOtb }));
    };
    return {
        userCart,
        discount_str: subscription.promo_code,
        getQuanityString,
        getFlavorString,
        isDuty,
        totalPrice,
        unlockSavings,
        rdImage,
        rdName,
        applyPromo,
        removePromo,
        promoError,
        isMobile,
        toggleDrawer,
        openSummaryDrawer,
        calculateTotalPriceWithoutBottle,
        shippingData,
    };
};
export default useCheckoutOrderSummary;
